<template>
  <div>
    <div v-if="!loading">
      <!-- <div class="row" v-if="isHome"> -->
      <!-- <div class="col-md-4">
          <div>
            <b-skeleton height="140px"></b-skeleton>
          </div>
          <div class="mt-3">
            <b-skeleton height="38px"></b-skeleton>
          </div>
        </div>
        <div class="col-md-4">
          <div>
            <b-skeleton height="140px"></b-skeleton>
          </div>
          <div class="mt-3">
            <b-skeleton height="38px"></b-skeleton>
          </div>
        </div>
        <div class="col-md-4">
          <div>
            <b-skeleton height="140px"></b-skeleton>
          </div>
          <div class="mt-3">
            <b-skeleton height="38px"></b-skeleton>
          </div>
        </div> -->

      <div class="row">
        <div class="col-md-4">
          <b-card no-body bg-variant="light-warning" class="mb-lg-0">
            <div class="card-body pl-0 pr-0">
              <div class="d-flex align-items-center p-5">
                <div class="mr-6">
                  <span class="svg-icon svg-icon svg-icon-7x">
                    <inline-svg
                      src="media/svg/icons/Shopping/Chart-line1.svg"
                    />
                  </span>
                </div>
                <div class="">
                  <span class="disableTextSelection">
                    &nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                  <b-skeleton></b-skeleton>

                  <div class="text-dark-75">
                    <b-skeleton width="25%"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
          <div>
            <b-button
              class="mt-3 mb-3 d-flex justify-content-center"
              variant="light-warning"
              block
            >
              <b-skeleton width="25%"></b-skeleton>
            </b-button>
          </div>
        </div>
        <div class="col-md-4">
          <!--begin::Callout-->
          <b-card no-body bg-variant="light-success" class="mb-lg-0">
            <div class="card-body pl-0 pr-0">
              <div class="d-flex align-items-center p-5">
                <!--begin::Icon-->
                <div class="mr-6">
                  <span class="svg-icon svg-icon svg-icon-7x">
                    <!--begin::Svg Icon | path:assets/media/svg/icons/Home/Mirror.svg-->
                    <inline-svg src="media/svg/icons/Shopping/Wallet.svg" />
                    <!--end::Svg Icon-->
                  </span>
                </div>
                <!--end::Icon-->
                <!--begin::Content-->
                <div class="">
                  <span class="disableTextSelection">
                    &nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                  <b-skeleton></b-skeleton>

                  <div class="text-dark-75">
                    <b-skeleton width="25%"></b-skeleton>
                  </div>
                </div>
                <!--end::Content-->
              </div>
            </div>
          </b-card>
          <!--end::Callout-->
          <div>
            <b-button
              class="mt-3 mb-3 d-flex justify-content-center"
              variant="light-success"
              block
            >
              <b-skeleton width="25%"></b-skeleton>
            </b-button>
          </div>
        </div>

        <div class="col-md-4">
          <b-card no-body bg-variant="light-warning" class="mb-lg-0">
            <div class="card-body pl-0 pr-0">
              <div class="d-flex align-items-center p-5">
                <div class="mr-6">
                  <span class="svg-icon svg-icon svg-icon-7x">
                    <inline-svg src="media/svg/icons/Shopping/Dollar.svg" />
                  </span>
                </div>
                <div class="">
                  <span class="disableTextSelection">
                    &nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                  <b-skeleton></b-skeleton>

                  <div class="text-dark-75">
                    <b-skeleton width="25%"></b-skeleton>
                  </div>
                </div>
                <!--end::Content-->
              </div>
            </div>
          </b-card>
          <!--end::Callout-->
          <div>
            <b-button
              class="mt-3 mb-3 d-flex justify-content-center"
              variant="light-warning"
              block
            >
              <b-skeleton width="25%"></b-skeleton>
            </b-button>
          </div>
        </div>
      </div>
      <!-- </div> -->

      <b-card class="mt-5">
        <b-row class="d-flex justify-content-end" align-v="center">
          <b-col><h4>تحلیل کسب و کار</h4></b-col>
          <b-col md="3" sm="6">
            <b-form-group label="از تاریخ:">
              <b-skeleton type="input"></b-skeleton>
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6">
            <b-form-group label="تا تاریخ:">
              <b-skeleton type="input"></b-skeleton>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-v="center">
          <b-col cols="12" md="6" sm="12">
            <b-row align-v="center">
              <b-col cols="12" md="4" sm="12" class="text-success">
                <li>ماکسیمم تعداد تراکنش</li>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="روز:">
                  <b-skeleton type="input"></b-skeleton>
                </b-form-group>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="تعداد:">
                  <b-skeleton type="input"></b-skeleton>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6" sm="12">
            <b-row align-v="center">
              <b-col cols="12" md="4" sm="12" class="text-danger">
                <li>مینیمم تعداد تراکنش</li>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="روز:">
                  <b-skeleton type="input"></b-skeleton>
                </b-form-group>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="تعداد:">
                  <b-skeleton type="input"></b-skeleton>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6" sm="12">
            <b-row align-v="center">
              <b-col cols="12" md="4" sm="12" class="text-success">
                <li>ماکسیمم ریالی تراکنش</li>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="روز:">
                  <b-skeleton type="input"></b-skeleton>
                </b-form-group>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="مبلغ(ریال):">
                  <b-skeleton type="input"></b-skeleton>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6" sm="12">
            <b-row align-v="center">
              <b-col cols="12" md="4" sm="12" class="text-danger">
                <li>مینیمم ریالی تراکنش</li>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="روز:">
                  <b-skeleton type="input"></b-skeleton>
                </b-form-group>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="مبلغ(ریال):">
                  <b-skeleton type="input"></b-skeleton>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>

      <div class="row">
        <div class="col-md-6">
          <b-card class="mt-5">
            <b-skeleton height="510px"></b-skeleton>
          </b-card>
        </div>
        <div class="col-md-6">
          <b-card class="mt-5">
            <b-skeleton height="510px"></b-skeleton>
          </b-card>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-4">
          <b-card no-body bg-variant="light-warning" class="mb-lg-0">
            <div class="card-body pl-0 pr-0">
              <div class="d-flex align-items-center p-5">
                <div class="mr-6">
                  <span class="svg-icon svg-icon-warning svg-icon-7x">
                    <inline-svg
                      src="media/svg/icons/Shopping/Chart-line1.svg"
                    />
                  </span>
                </div>
                <div class="d-flex flex-column">
                  <span
                    class="
                      text-dark text-hover-warning
                      font-weight-bold font-size-h4
                      mb-3
                    "
                    >تعداد تراکنش های امروز</span
                  >
                  <div class="text-dark-75" v-if="transCount.length == 0">
                    0 عدد
                  </div>
                  <div v-else>
                    <div
                      class="text-dark-75"
                      v-for="x of transCount"
                      :key="x.title"
                    >
                      <b-row>
                        <b-col> {{ x.title }}ی : </b-col>
                        <b-col> {{ x.count }} عدد </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
          <b-button
            class="mt-3 mb-3"
            href="/reports"
            variant="light-warning"
            block
            >آمار و نمودار ها</b-button
          >
        </div>
        <div class="col-md-4">
          <!--begin::Callout-->
          <b-card no-body bg-variant="light-success" class="mb-lg-0">
            <div class="card-body pl-0 pr-0">
              <div class="d-flex align-items-center p-5">
                <!--begin::Icon-->
                <div class="mr-6">
                  <span class="svg-icon svg-icon-success svg-icon-7x">
                    <!--begin::Svg Icon | path:assets/media/svg/icons/Home/Mirror.svg-->
                    <inline-svg src="media/svg/icons/Shopping/Wallet.svg" />
                    <!--end::Svg Icon-->
                  </span>
                </div>
                <!--end::Icon-->
                <!--begin::Content-->
                <div class="d-flex flex-column">
                  <span
                    class="
                      text-dark text-hover-warning
                      font-weight-bold font-size-h4
                      mb-3
                    "
                    >مبلغ تراکنش های امروز </span
                  ><small
                    style="font-size: 0.7rem"
                    class="text-hover-warning text-dark"
                    >(بدون احتساب کارمزد)</small
                  >
                  <div class="text-dark-75" v-if="transSum.length == 0">0</div>
                  <div v-else>
                    <div
                      class="text-dark-75"
                      v-for="x of transSum"
                      :key="x.title"
                    >
                      <b-row>
                        <b-col cols="8" class="text-right">
                          {{ x.sum }}
                        </b-col>
                        <b-col> {{ x.title }} </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
                <!--end::Content-->
              </div>
            </div>
          </b-card>
          <!--end::Callout-->
          <b-button
            class="mt-3 mb-3"
            href="/gardesh"
            variant="light-success"
            block
            >تراکنش ها</b-button
          >
        </div>

        <div class="col-md-4">
          <!--begin::Callout-->
          <!-- <div bg-variant='success' class="card card-custom mb-lg-0">
              
            </div> -->
          <b-card
            no-body
            bg-variant="light-warning"
            class="mb-lg-0"
            style="height: calc(100% - 58px)"
          >
            <div class="card-body pl-0 pr-0">
              <div class="d-flex align-items-center p-5">
                <!--begin::Icon-->
                <div class="mr-6">
                  <span class="svg-icon svg-icon-warning svg-icon-7x">
                    <!--begin::Svg Icon | path:assets/media/svg/icons/Home/Mirror.svg-->
                    <inline-svg src="media/svg/icons/Shopping/Dollar.svg" />
                    <!--end::Svg Icon-->
                  </span>
                </div>
                <!--end::Icon-->
                <!--begin::Content-->
                <div class="d-flex flex-column">
                  <span
                    class="
                      text-dark text-hover-warning
                      font-weight-bold font-size-h4
                      mb-3
                    "
                    >مبلغ در حال تسویه:</span
                  >
                  <div class="text-dark-75">{{ isPaying }} ريال</div>
                </div>
                <!--end::Content-->
              </div>
            </div>
          </b-card>
          <!--end::Callout-->
          <b-button
            class="mt-3 mb-3"
            href="/share"
            variant="light-warning"
            block
            >تسویه ها</b-button
          >
        </div>
      </div>

      <!-- <b-row v-if="changeStatus">
          <b-col cols="12" md="12" sm="12">
            <b-skeleton height="240px"></b-skeleton>
          </b-col>

          <b-col md="6" sm="6">
            <b-skeleton height="240px"></b-skeleton>
          </b-col>
          <b-col md="6" sm="6">
            <b-skeleton height="240px"></b-skeleton>
          </b-col>
          <b-col md="6" sm="6">
            <b-skeleton height="240px"></b-skeleton>
          </b-col>
          <b-col md="6" sm="6">
            <b-skeleton height="240px"></b-skeleton>
          </b-col>
        </b-row> -->

      <b-card>
        <b-row class="d-flex justify-content-end" align-v="center">
          <b-col><h4>تحلیل کسب و کار</h4></b-col>
          <b-col md="3" sm="6">
            <b-form-group label="از تاریخ:">
              <date-picker
                clearable
                @change="getBiSource"
                v-model="date_from"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6">
            <b-form-group label="تا تاریخ:">
              <date-picker
                clearable
                @change="getBiSource"
                v-model="date_to"
              ></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-v="center">
          <b-col cols="12" md="6" sm="12">
            <b-row align-v="center">
              <b-col cols="12" md="4" sm="12" class="text-success">
                <li>ماکسیمم تعداد تراکنش</li>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="روز:">
                  <div class="form-control border-success">
                    {{ this.maxMin.max_count.date }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="تعداد:">
                  <div class="form-control border-success">
                    {{ this.maxMin.max_count.length }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6" sm="12">
            <b-row align-v="center">
              <b-col cols="12" md="4" sm="12" class="text-danger">
                <li>مینیمم تعداد تراکنش</li>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="روز:">
                  <div class="form-control border-danger">
                    {{ this.maxMin.min_count.date }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="تعداد:">
                  <div class="form-control border-danger">
                    {{ this.maxMin.min_count.length }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6" sm="12">
            <b-row align-v="center">
              <b-col cols="12" md="4" sm="12" class="text-success">
                <li>ماکسیمم ریالی تراکنش</li>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="روز:">
                  <div class="form-control border-success">
                    {{ this.maxMin.max_cost.date }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="مبلغ(ریال):">
                  <div class="form-control border-success">
                    {{ this.maxMin.max_cost.sumCost.toLocaleString() }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6" sm="12">
            <b-row align-v="center">
              <b-col cols="12" md="4" sm="12" class="text-danger">
                <li>مینیمم ریالی تراکنش</li>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="روز:">
                  <div class="form-control border-danger">
                    {{ this.maxMin.min_cost.date }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="6" md="4" sm="6">
                <b-form-group label="مبلغ(ریال):">
                  <div class="form-control border-danger">
                    {{ this.maxMin.min_cost.sumCost.toLocaleString() }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <div class="row">
        <div class="col-md-6">
          <shepaChart
            v-bind:chartdatas="ChartDatas"
            v-bind:charttype="'column'"
            v-bind:group_col="'persian_date'"
            v-bind:columns="[
              {
                name: '',
                field_name: 'cost',
                field_type: 'length',
              },
            ]"
            v-bind:title="'نمودار تعداد تراکنش ها'"
            :XYTitle="{ x_title: 'تاریخ', y_title: 'تعداد' }"
            :biId="-1"
            :resetcharts="resetCharts"
            :datebefore="'1399/09/15'"
          ></shepaChart>
        </div>
        <div class="col-md-6">
          <shepaChart
            v-bind:chartdatas="ChartDatas"
            v-bind:charttype="'line'"
            v-bind:group_col="'persian_date'"
            v-bind:columns="[
              {
                name: 'مجموع پرداختی',
                field_name: 'cost',
                field_type: 'sum',
              },
            ]"
            v-bind:title="'نمودار ریال تراکنش ها(تاریخ ، مبلغ)'"
            :XYTitle="{ x_title: 'تاریخ', y_title: 'مبلغ' }"
            :biId="-2"
            :resetcharts="resetCharts"
          ></shepaChart>
        </div>
        <div class="col-md-6">
          <shepaChart
            v-bind:chartdatas="ChartDatas"
            v-bind:charttype="'heat'"
            v-bind:group_col="'dayofweek'"
            v-bind:columns="[
              {
                id: 2,
                name: 'روز های هفته',
                field: 'sum(cost)',
                sourse_id: 1,
                field_type: 'sum',
                field_name: 'cost',
              },
            ]"
            v-bind:title="'نمودار ساعات پرفروش هفته'"
            :XYTitle="{ x_title: 'ساعت', y_title: 'روز' }"
            :biId="-4"
            :resetcharts="resetCharts"
          ></shepaChart>
          <!-- <shepaChart
              v-bind:chartdatas="ChartDatas"
              v-bind:charttype="'line2'"
              v-bind:group_col="'dayofweek'"
              v-bind:columns="[
                {
                  name: 'مجموع پرداختی',
                  field_name: 'cost',
                  field_type: 'length',
                }
              ]"
              v-bind:title="'نمودار ساعات پرفروش هفته'"
              :biId="-4"
              :resetcharts="resetCharts"
            ></shepaChart> -->
        </div>
        <div class="col-md-6">
          <shepaChart
            v-bind:chartdatas="ChartDatas"
            v-bind:charttype="'column'"
            v-bind:group_col="'dayofweek'"
            v-bind:columns="[
              {
                name: 'مجموع پرداختی',
                field_name: 'cost',
                field_type: 'sum',
              },
            ]"
            v-bind:title="'نمودار زمان تراکنش ها(روز هفته)'"
            :XYTitle="{ x_title: 'روز', y_title: 'مبلغ' }"
            :biId="-3"
            :resetcharts="resetCharts"
          ></shepaChart>
        </div>
      </div>
    </div>

    <!-- <div class="row" v-if="!isHome">
        <div class="col-md-12">
          <b-button href="/BI" variant="success">نمودار جدید</b-button>
        </div>
      </div>
      <div class="row" v-if="!isHome">
        <div class="col-md-6" v-for="chart in chartList" v-bind:key="chart.id">
          <shepaChart
            v-bind:chartdatas="ChartDatas"
            v-bind:charttype="chart.type.code"
            v-bind:group_col="chart.x_axis"
            v-bind:columns="chart.y_axis"
            v-bind:title="chart.name"
            :biId="chart.id"
            :resetcharts="resetCharts"
          ></shepaChart>
        </div>
      </div> -->
  </div>
</template>
<script>
import httpHelper from "../helpers/httpHelper";
import shepaChart from "../components/chart";
import persianDate from "../helpers/persianDate";
import _ from "lodash";

export default {
  name: "BI",
  props: ["id", "isHome"],
  data() {
    return {
      dollarPrice: 0,
      isPaying: 0,
      ChartDatas: [],
      chartList: [],
      transCount: [],
      transSum: [],
      maxMin: {
        max_count: { date: 0, length: 0, sumCost: 0 },
        min_count: { date: 0, length: 0, sumCost: 0 },
        max_cost: { date: 0, length: 0, sumCost: 0 },
        min_cost: { date: 0, length: 0, sumCost: 0 },
      },
      payable: 0,
      dataLoaded: false,
      changeStatus: false,
      date_from: persianDate.getDateByFormat(
        new Date().setDate(new Date().getDate() - 7)
      ),
      date_to: persianDate.getDateByFormat(new Date()),
      loading: false,
    };
  },
  components: { shepaChart },
  mounted() {
    // httpHelper.getData("exchange").then((res) => {
    //   this.dollarPrice = Number(
    //     res.result.find(function (o) {
    //       return (
    //         o.mdid115_international_gateway == 1735 &&
    //         o.mdid12_money_type == 1722
    //       );
    //     }).value
    //   ).toLocaleString();
    // });
    httpHelper.getData("~transaction/reports/paying").then((res) => {
      this.isPaying = Number(res.result.amount).toLocaleString();
    });
    // httpHelper.getData("BI").then((res) => {
    //   this.chartList = res.result;
    //   for (let i = 0; i < this.chartList.length; i++) {
    //     const element = this.chartList[i];
    //     this.chartList[i].y_axis = eval("(" + this.chartList[i].y_axis + ")");
    //   }
    //   this.dataLoaded = true;

    //   // httpHelper.getData("getsattlable").then((res) => {
    //   //   //this.ticketCount = res.result;

    //   //   if (res.success) {
    //   //     if (res.result.length > 0) {
    //   //       this.payable = Number(res.result[0].payable).toLocaleString();
    //   //     }
    //   //   }
    //   // });
    // });
    this.getBiSource();
  },
  methods: {
    resetCharts() {
      httpHelper.getData("BI").then((res) => {
        this.chartList = res.result;
        for (let i = 0; i < this.chartList.length; i++) {
          const element = this.chartList[i];
          this.chartList[i].y_axis = eval("(" + this.chartList[i].y_axis + ")");
        }
      });
    },
    widgetDatas() {
      this.transSum = [];
      this.transCount = [];
      var data = _.filter(this.ChartDatas, function (o) {
        return o.persian_date == persianDate.getDateByFormat(new Date());
      });
      var groupedByMoney = _.groupBy(data, function (o) {
        return o.money_type;
      });
      for (const key in groupedByMoney) {
        if (Object.hasOwnProperty.call(groupedByMoney, key)) {
          const element = groupedByMoney[key];
          this.transCount.push({
            title: key,
            count: Number(element.length).toLocaleString(),
          });
          this.transSum.push({
            title: key,
            sum: Number(_.sumBy(element, "cost")).toLocaleString(),
          });
        }
      }
      //this.transCount = Number(data.length).toLocaleString();
      // this.transSum = Number(
      //   _.sumBy(data, function (o) {
      //     return o.cost;
      //   })
      // ).toLocaleString();
    },
    getBiSource() {
      this.loading = false;
      this.ChartDatas = [];
      httpHelper
        .getData(
          `~/transaction/transaction/BI/biSource?datefrom=${this.date_from}&dateto=${this.date_to}`
        )
        .then((res) => {
          this.loading = true;
          this.ChartDatas = res.result;
          this.getMinMax(this.ChartDatas);

          if (this.transCount.length == 0) {
            this.widgetDatas();
          }
        });
    },
    getMinMax(data) {
      var filtered = [];
      var groupedData = _.groupBy(data, "persian_date");
      for (const key in groupedData) {
        if (Object.hasOwnProperty.call(groupedData, key)) {
          const element = groupedData[key];
          filtered.push({
            date: key,
            sumCost: _.sumBy(element, "cost"),
            length: element.length,
          });
        }
      }
      let min_count = _.minBy(filtered, (o) => {
        return o.length;
      });
      let max_count = _.maxBy(filtered, (o) => {
        return o.length;
      });
      let min_cost = _.minBy(filtered, (o) => {
        return o.sumCost;
      });
      let max_cost = _.maxBy(filtered, (o) => {
        return o.sumCost;
      });
      Object.assign(this.maxMin, {
        min_count: filtered.length!=0 ? min_count : { date: 0, length: 0, sumCost: 0 },
        max_count: filtered.length!=0 ? max_count : { date: 0, length: 0, sumCost: 0 },
        min_cost: filtered.length!=0 ? min_cost : { date: 0, length: 0, sumCost: 0 },
        max_cost: filtered.length!=0 ? max_cost : { date: 0, length: 0, sumCost: 0 },
      });
      // let max_amount;
      // let min_amount;
    },
  },
};
</script>
<style scoped>
.disableTextSelection {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>